import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";

import api from "../../api/api";
import {
    useLayoutEffect
} from "react";
import {
    useAcademicYear,
} from "../../AcademicYearContext";

import Swal from "sweetalert2";

// import {
//     PDFDownloadLink,
// } from "@react-pdf/renderer";

import {
pdf,
} from "@react-pdf/renderer";

import Test from "./Test";
import TestPDF from "./TestPDF";

import {
    AccessTime,
    Close,
    Delete,
    Edit,
    PictureAsPdf,
    Quiz,
    School,
    Search,
    Subject,
} from "@mui/icons-material";

import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    InputAdornment,
    MenuItem,
    Pagination,
    Paper,
    Select,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";

const COLORS = {
    black: "#111111",
    darkBlack: "#1B1B1B",
    orange: "#F28C28",
    camel: "#C19A6B",
    lightCamel: "#F5EBDD",
    cream: "#FAF8F4",
    white: "#FFFFFF",
    gray: "#6B7280",
    lightGray: "#F3F4F6",
    border: "#E5E7EB",
    red: "#C62828",
};

const getTestName = test =>
    test.direction?.trim() || "Test Paper";

const getTestSubject = test =>
    test.subject_name ||
    test.subject?.name ||
    "Unknown Subject";

const getTestGrade = test =>
    test.grade_class_name ||
    test.grade_class?.name ||
    "Unknown Grade";

const getTestPeriod = test =>
    test.period_name ||
    test.period?.name ||
    "Unknown Period";

const formatDateTime = value => {
    if (!value) {
        return "Not available";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
        return "Invalid date";
    }

    return date.toLocaleString();
};

const truncateText = (
    value,
    length = 50
) => {
    if (!value) {
        return "Test Paper";
    }

    if (value.length <= length) {
        return value;
    }

    return `${value.slice(0, length)}...`;
};

const TestPraint = () => {
    const theme = useTheme();

    const isMobile = useMediaQuery(
        theme.breakpoints.down("md")
    );

    const {
        selectedYear,
    } = useAcademicYear();

    const [
        tests,
        setTests,
    ] = useState([]);

    const [
        periods,
        setPeriods,
    ] = useState([]);

    const [
        loading,
        setLoading,
    ] = useState(false);

    const [
        periodsLoading,
        setPeriodsLoading,
    ] = useState(false);

    const [
        error,
        setError,
    ] = useState("");

    const [
        searchQuery,
        setSearchQuery,
    ] = useState("");

    const [
        debouncedSearch,
        setDebouncedSearch,
    ] = useState("");

    const [
        page,
        setPage,
    ] = useState(1);

    const [
        totalPages,
        setTotalPages,
    ] = useState(1);

    const [
        totalCount,
        setTotalCount,
    ] = useState(0);

    const [
        rowsPerPage,
        setRowsPerPage,
    ] = useState(20);

    const [
        ordering,
        setOrdering,
    ] = useState("-created_at");

    const [
        gradeClassFilter,
        setGradeClassFilter,
    ] = useState("");

    const [
        subjectFilter,
        setSubjectFilter,
    ] = useState("");

    const [
        periodFilter,
        setPeriodFilter,
    ] = useState("");

    const [
        deleteId,
        setDeleteId,
    ] = useState(null);

    const [
        deleting,
        setDeleting,
    ] = useState(false);

    const [
    pdfLoadingId,
    setPdfLoadingId,
] = useState(null);

const [selectedTest, setSelectedTest] = useState(null);

const [
    editTest,
    setEditTest,
] = useState(null);
const [
    pdfTest,
    setPdfTest
] = useState(null);

    const [
        editDialogOpen,
        setEditDialogOpen,
    ] = useState(false);

    const token = localStorage.getItem("access");

    const authHeaders = useMemo(
        () => ({
            Authorization: `Bearer ${token}`,
        }),
        [token]
    );



//     const handlePDF = async (test) => {

//     const fullTest =
//         await getFullTestForPDF(
//             test.id
//         );

//     if(fullTest){
//         setPdfTest(fullTest);
//     }
// };


const handlePDF = async (test) => {

    try {

        setPdfLoadingId(test.id);


        const fullTest =
            await getFullTestForPDF(
                test.id
            );


        if(!fullTest){
            return;
        }


        const blob =
            await pdf(
                <TestPDF
                    test={fullTest}
                />
            ).toBlob();


        const url =
            URL.createObjectURL(blob);


        const link =
            document.createElement(
                "a"
            );


        link.href = url;

        link.download =
            `test_${test.id}_paper.pdf`;


        document.body.appendChild(link);

        link.click();


        document.body.removeChild(link);


        URL.revokeObjectURL(url);



        Swal.fire({
            icon: "success",
            title: "Downloaded",
            text: "Test PDF downloaded successfully.",
            timer: 2000,
            showConfirmButton: false,
        });


    } catch(error){

        console.error(
            "PDF DOWNLOAD ERROR:",
            error
        );


        Swal.fire(
            "Error",
            "Unable to download test PDF.",
            "error"
        );


    } finally {

        setPdfLoadingId(null);

    }

};

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);

        return () => {
            clearTimeout(timer);
        };
    }, [searchQuery]);

    /*
    =====================================================
    FETCH AVAILABLE PERIODS FOR SELECTED ACADEMIC YEAR
    =====================================================
    */
const handleEdit = async (id) => {

    try {

        // console.log(
        //     "LOADING FULL TEST:",
        //     id
        // );


        const response = await api.get(
            `/api/periodic-tests/${id}/`,
            {
                headers: authHeaders
            }
        );

        


        // console.log(
        //     "FULL TEST FROM API:",
        //     response.data
        // );


        // console.log(
        //     "FULL TEST SECTIONS:",
        //     response.data.sections
        // );


        setSelectedTest(
            response.data
        );


        setEditDialogOpen(true);


    } catch(error){

        console.error(
            "FAILED LOADING TEST:",
            error.response?.data || error
        );


        Swal.fire(
            "Error",
            "Unable to load test details.",
            "error"
        );

    }

};

const getFullTestForPDF = async (id) => {
    try {

        const response = await api.get(
            `/api/periodic-tests/${id}/`,
            {
                headers: authHeaders,
            }
        );

        return response.data;

    } catch(error){

        console.error(
            "FAILED LOADING PDF TEST:",
            error.response?.data || error
        );

        Swal.fire(
            "Error",
            "Unable to load full test questions.",
            "error"
        );

        return null;
    }
};

    const fetchPeriods = useCallback(
        async () => {
            if (!selectedYear?.id) {
                setPeriods([]);
                setPeriodFilter("");
                return;
            }

            setPeriodsLoading(true);

            try {
                const response = await api.get(
                    "/api/periodic-tests/periods/",
                    {
                        headers: authHeaders,
                        params: {
                            academic_year: selectedYear.id,
                        },
                    }
                );

                const periodData = Array.isArray(
                    response.data
                )
                    ? response.data
                    : [];

                setPeriods(periodData);

                /*
                If the currently selected period does
                not exist in the new academic year,
                clear it.
                */

                setPeriodFilter(previousPeriod => {
                    const stillExists = periodData.some(
                        period =>
                            String(period.id) ===
                            String(previousPeriod)
                    );

                    return stillExists
                        ? previousPeriod
                        : "";
                });
            }

            catch (requestError) {
                console.error(
                    "Failed to load periods:",
                    requestError.response?.data ||
                    requestError
                );

                setPeriods([]);

                setPeriodFilter("");

                Swal.fire(
                    "Error",
                    "Failed to load test periods.",
                    "error"
                );
            }

            finally {
                setPeriodsLoading(false);
            }
        },
        [
            authHeaders,
            selectedYear?.name,
        ]
    );

    useEffect(() => {
        fetchPeriods();
    }, [fetchPeriods]);

    /*
    =====================================================
    RESET TO PAGE 1 WHEN FILTERS CHANGE
    =====================================================
    */

    useEffect(() => {
        setPage(1);
    }, [
        debouncedSearch,
        gradeClassFilter,
        subjectFilter,
        periodFilter,
        rowsPerPage,
        ordering,
        selectedYear?.id,
    ]);

    /*
    =====================================================
    FETCH TESTS
    =====================================================
    */

    const fetchTests = useCallback(
        async () => {
            if (!selectedYear?.id) {
                setTests([]);
                setTotalPages(1);
                setTotalCount(0);
                setLoading(false);
                return;
            }

            setLoading(true);
            setError("");

            try {
                const response = await api.get(
                    "/api/periodic-tests/",
                    {
                        headers: authHeaders,
                       params: {
                       page,
                       page_size: rowsPerPage,
                       academic_year: selectedYear.id,

                            /*
                            This is now the PERIOD ID
                            returned by /periods/.
                            */

                            ...(periodFilter && {
                                period: periodFilter,
                            }),

                            ...(gradeClassFilter && {
                                grade_class: gradeClassFilter,
                            }),

                            ...(subjectFilter && {
                                subject: subjectFilter,
                            }),

                            ...(debouncedSearch && {
                                search: debouncedSearch,
                            }),

                            ordering,
                        },
                    }
                );

                const responseData =
                    response.data;

                const results = Array.isArray(
                    responseData
                )
                    ? responseData
                    : responseData.results || [];

                setTests(results);

                const count = Number(
                    responseData.count ||
                    results.length
                );

                setTotalCount(count);

                const backendPageSize =
                    Number(
                        responseData.page_size ||
                        rowsPerPage
                    );

                const backendTotalPages =
                    Number(
                        responseData.total_pages ||
                        0
                    );

                const calculatedPages =
                    backendTotalPages ||
                    (
                        count > 0
                            ? Math.ceil(
                                count /
                                backendPageSize
                            )
                            : 1
                    );

                setTotalPages(
                    calculatedPages
                );
            }

            catch (requestError) {
                console.error(
                    "Failed to fetch tests:",
                    requestError.response?.data ||
                    requestError
                );

                setError(
                    "Failed to load tests."
                );

                setTests([]);
                setTotalPages(1);
                setTotalCount(0);

                Swal.fire(
                    "Error",
                    "Failed to load tests.",
                    "error"
                );
            }

            finally {
                setLoading(false);
            }
        },
        [
            authHeaders,
            page,
            rowsPerPage,
            debouncedSearch,
            selectedYear?.name,
            gradeClassFilter,
            subjectFilter,
            periodFilter,
            ordering,
        ]
    );

    useEffect(() => {
        fetchTests();
    }, [fetchTests]);

    /*
    =====================================================
    DELETE
    =====================================================
    */

    const confirmDelete = id => {
        setDeleteId(id);
    };

    const cancelDelete = () => {
        if (deleting) {
            return;
        }

        setDeleteId(null);
    };

    const handleDelete = async () => {
        if (!deleteId) {
            return;
        }

        setDeleting(true);

        try {
            await api.delete(
                `/api/periodic-tests/${deleteId}/`,
                {
                    headers: authHeaders,
                }
            );

            setDeleteId(null);

            Swal.fire(
                "Deleted!",
                "The test has been deleted.",
                "success"
            );

            if (
                tests.length === 1 &&
                page > 1
            ) {
                setPage(
                    previousPage =>
                        previousPage - 1
                );
            }
            else {
                await fetchTests();
            }
        }

        catch (requestError) {
            console.error(
                "Failed to delete test:",
                requestError.response?.data ||
                requestError
            );

            Swal.fire(
                "Error",
                "Failed to delete the test.",
                "error"
            );
        }

        finally {
            setDeleting(false);
        }
    };

    /*
    =====================================================
    CLEAR FILTERS
    =====================================================
    */

    const clearFilters = () => {
        setSearchQuery("");
        setDebouncedSearch("");
        setGradeClassFilter("");
        setSubjectFilter("");
        setPeriodFilter("");
        setOrdering("-created_at");
        setPage(1);
    };

    const hasFilters = Boolean(
        searchQuery ||
        gradeClassFilter ||
        subjectFilter ||
        periodFilter
    );

    if (
        loading &&
        tests.length === 0
    ) {
        return (
            <Box
                sx={{
                    minHeight: "80vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: COLORS.cream,
                }}
            >
                <CircularProgress
                    sx={{
                        color: COLORS.orange,
                    }}
                />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                minHeight: "100vh",
                backgroundColor: COLORS.cream,
                p: {
                    xs: 1.5,
                    sm: 2.5,
                    md: 4,
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    justifyContent: "space-between",
                    alignItems: {
                        xs: "flex-start",
                        md: "center",
                    },
                    gap: 2,
                    mb: 3,
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontSize: {
                                xs: 24,
                                sm: 30,
                                md: 36,
                            },
                            fontWeight: 800,
                            color: COLORS.black,
                        }}
                    >
                        My Posted Tests
                    </Typography>

                    <Typography
                        sx={{
                            color: COLORS.gray,
                            fontSize: 14,
                            mt: 0.5,
                        }}
                    >
                        Select a period to load only
                        the tests for that period.
                    </Typography>

                    {selectedYear && (
                        <Chip
                            label={
                                `Academic Year: ` +
                                selectedYear.name
                            }
                            size="small"
                            sx={{
                                mt: 1,
                                backgroundColor:
                                    COLORS.lightCamel,
                                color: COLORS.black,
                                fontWeight: 700,
                            }}
                        />
                    )}
                </Box>

                <Chip
                    icon={<Quiz />}
                    label={`${totalCount} Tests`}
                    sx={{
                        backgroundColor:
                            COLORS.black,
                        color: COLORS.white,
                        fontWeight: 700,
                        px: 1,
                        "& .MuiChip-icon": {
                            color: COLORS.orange,
                        },
                    }}
                />
            </Box>

            <Paper
                elevation={0}
                sx={{
                    p: {
                        xs: 1.5,
                        md: 2,
                    },
                    mb: 3,
                    borderRadius: 3,
                    border:
                        `1px solid ${COLORS.border}`,
                    backgroundColor:
                        COLORS.white,
                }}
            >
                <Stack spacing={2}>
                    <TextField
                        fullWidth
                        value={searchQuery}
                        placeholder={
                            "Search within the selected period..."
                        }
                        onChange={event => {
                            setSearchQuery(
                                event.target.value
                            );
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment
                                    position="start"
                                >
                                    <Search
                                        sx={{
                                            color:
                                                COLORS.orange,
                                        }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                            },
                        }}
                    />

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(2, 1fr)",
                                md: "repeat(4, 1fr)",
                            },
                            gap: 1.5,
                        }}
                    >
                        <TextField
                            label="Grade Class"
                            value={gradeClassFilter}
                            onChange={event => {
                                setGradeClassFilter(
                                    event.target.value
                                );
                            }}
                            placeholder="Example: Grade 7"
                            size="small"
                        />

                        <TextField
                            label="Subject"
                            value={subjectFilter}
                            onChange={event => {
                                setSubjectFilter(
                                    event.target.value
                                );
                            }}
                            placeholder="Example: Mathematics"
                            size="small"
                        />

                        <Select
                            fullWidth
                            size="small"
                            displayEmpty
                            value={periodFilter}
                            onChange={event => {
                                setPeriodFilter(
                                    event.target.value
                                );
                            }}
                            disabled={
                                periodsLoading ||
                                !selectedYear
                            }
                        >
                            <MenuItem value="">
                                {periodsLoading
                                    ? "Loading periods..."
                                    : "Select Period"}
                            </MenuItem>

                            {periods.map(period => (
                                <MenuItem
                                    key={period.id}
                                    value={period.id}
                                >
                                    {period.name}
                                </MenuItem>
                            ))}
                        </Select>

                        <Select
                            fullWidth
                            size="small"
                            value={ordering}
                            onChange={event => {
                                setOrdering(
                                    event.target.value
                                );
                            }}
                        >
                            <MenuItem value="-created_at">
                                Newest First
                            </MenuItem>

                            <MenuItem value="created_at">
                                Oldest First
                            </MenuItem>

                            <MenuItem value="direction">
                                Test Name A-Z
                            </MenuItem>

                            <MenuItem value="-direction">
                                Test Name Z-A
                            </MenuItem>

                            <MenuItem value="start_time">
                                Earliest Start
                            </MenuItem>

                            <MenuItem value="-start_time">
                                Latest Start
                            </MenuItem>
                        </Select>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent:
                                "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 1,
                        }}
                    >
                        <Typography
                            fontSize={13}
                            color={COLORS.gray}
                        >
                            {periodFilter
                                ? "Showing tests from the selected period."
                                : "Select a period to filter tests."}
                        </Typography>

                        {hasFilters && (
                            <Button
                                onClick={
                                    clearFilters
                                }
                                sx={{
                                    color:
                                        COLORS.black,
                                    fontWeight: 700,
                                }}
                            >
                                Clear Filters
                            </Button>
                        )}
                    </Box>
                </Stack>
            </Paper>

            {loading && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent:
                            "center",
                        mb: 2,
                    }}
                >
                    <CircularProgress
                        size={26}
                        sx={{
                            color:
                                COLORS.orange,
                        }}
                    />
                </Box>
            )}

            {!isMobile && (
                <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                        borderRadius: 3,
                        border:
                            `1px solid ${COLORS.border}`,
                        overflow: "hidden",
                    }}
                >
                    <Table>
                        <TableHead>
                            <TableRow
                                sx={{
                                    backgroundColor:
                                        COLORS.black,
                                }}
                            >
                                {[
                                    "Test",
                                    "Grade Class",
                                    "Subject",
                                    "Period",
                                    "Schedule",
                                    "Actions",
                                ].map(header => (
                                    <TableCell
                                        key={header}
                                        sx={{
                                            color:
                                                COLORS.white,
                                            fontWeight:
                                                800,
                                            py: 2,
                                        }}
                                    >
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {tests.map(test => (
                                <TableRow
                                    key={test.id}
                                    hover
                                    sx={{
                                        "&:hover": {
                                            backgroundColor:
                                                COLORS.lightCamel,
                                        },
                                    }}
                                >
                                    <TableCell>
                                        <Typography
                                            fontWeight={700}
                                        >
                                            {truncateText(
                                                getTestName(
                                                    test
                                                ),
                                                45
                                            )}
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            icon={
                                                <School />
                                            }
                                            label={
                                                getTestGrade(
                                                    test
                                                )
                                            }
                                            size="small"
                                            sx={{
                                                backgroundColor:
                                                    COLORS.lightCamel,
                                                color:
                                                    COLORS.black,
                                                fontWeight:
                                                    700,
                                            }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            gap={1}
                                        >
                                            <Subject
                                                sx={{
                                                    color:
                                                        COLORS.orange,
                                                }}
                                            />

                                            {getTestSubject(
                                                test
                                            )}
                                        </Stack>
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            label={
                                                getTestPeriod(
                                                    test
                                                )
                                            }
                                            size="small"
                                            sx={{
                                                backgroundColor:
                                                    COLORS.black,
                                                color:
                                                    COLORS.white,
                                            }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Typography
                                            fontSize={12}
                                            color={
                                                COLORS.gray
                                            }
                                        >
                                            {formatDateTime(
                                                test.start_time
                                            )}

                                            <br />

                                            to

                                            <br />

                                            {formatDateTime(
                                                test.end_time
                                            )}
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                        >
                                            <IconButton
                                                onClick={() => {
                                                    handleEdit(test.id);
                                                }}
                                            >
                                                <Edit />
                                            </IconButton>

<IconButton
    onClick={() => handlePDF(test)}
    disabled={
        pdfLoadingId === test.id
    }
    sx={{
        backgroundColor:
            COLORS.orange,
        color:
            COLORS.white,

        "&:hover":{
            backgroundColor:
                "#D97706",
        }
    }}
>
{
pdfLoadingId === test.id
?
<CircularProgress
    size={22}
    sx={{
        color:
        COLORS.white
    }}
/>
:
<PictureAsPdf />
}

</IconButton>

                                            <IconButton
                                                onClick={() => {
                                                    confirmDelete(
                                                        test.id
                                                    );
                                                }}
                                                sx={{
                                                    backgroundColor:
                                                        "#FDECEC",
                                                    color:
                                                        COLORS.red,
                                                    "&:hover": {
                                                        backgroundColor:
                                                            "#F8D7DA",
                                                    },
                                                }}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {isMobile && (
                <Stack spacing={2}>
                    {tests.map(test => (
                        <Paper
                            key={test.id}
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 3,
                                border:
                                    `1px solid ${COLORS.border}`,
                                backgroundColor:
                                    COLORS.white,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent:
                                        "space-between",
                                    gap: 1,
                                    mb: 1.5,
                                }}
                            >
                                <Typography
                                    fontWeight={800}
                                    color={
                                        COLORS.black
                                    }
                                >
                                    {truncateText(
                                        getTestName(
                                            test
                                        ),
                                        35
                                    )}
                                </Typography>

                                <Chip
                                    label={
                                        getTestPeriod(
                                            test
                                        )
                                    }
                                    size="small"
                                    sx={{
                                        backgroundColor:
                                            COLORS.black,
                                        color:
                                            COLORS.white,
                                    }}
                                />
                            </Box>

                            <Divider
                                sx={{
                                    mb: 1.5,
                                }}
                            />

                            <Stack spacing={1}>
                                <Stack
                                    direction="row"
                                    gap={1}
                                    alignItems="center"
                                >
                                    <School
                                        fontSize="small"
                                        sx={{
                                            color:
                                                COLORS.orange,
                                        }}
                                    />

                                    <Typography
                                        fontSize={13}
                                    >
                                        {getTestGrade(
                                            test
                                        )}
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    gap={1}
                                    alignItems="center"
                                >
                                    <Subject
                                        fontSize="small"
                                        sx={{
                                            color:
                                                COLORS.orange,
                                        }}
                                    />

                                    <Typography
                                        fontSize={13}
                                    >
                                        {getTestSubject(
                                            test
                                        )}
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    gap={1}
                                    alignItems="center"
                                >
                                    <AccessTime
                                        fontSize="small"
                                        sx={{
                                            color:
                                                COLORS.orange,
                                        }}
                                    />

                                    <Typography
                                        fontSize={12}
                                        color={
                                            COLORS.gray
                                        }
                                    >
                                        {formatDateTime(
                                            test.start_time
                                        )}
                                    </Typography>
                                </Stack>
                            </Stack>

                            <Stack
                                direction="row"
                                spacing={1}
                                mt={2}
                            >
                                    <Button
                            onClick={() => handleEdit(test.id)}
                        >
                            Edit
                        </Button>
                              <IconButton
    onClick={() => handlePDF(test)}
    disabled={
        pdfLoadingId === test.id
    }
    sx={{
        backgroundColor:
            COLORS.orange,
        color:
            COLORS.white,
        flex:1,
        borderRadius:2,

        "&:hover":{
            backgroundColor:
            "#D97706"
        }
    }}
>
{
pdfLoadingId === test.id
?
<CircularProgress
size={22}
sx={{
color:COLORS.white
}}
/>
:
<PictureAsPdf/>
}
</IconButton>

                                <IconButton
                                    onClick={() => {
                                        confirmDelete(
                                            test.id
                                        );
                                    }}
                                    sx={{
                                        color:
                                            COLORS.red,
                                        border:
                                            "1px solid #F0B7B7",
                                    }}
                                >
                                    <Delete />
                                </IconButton>
                            </Stack>
                        </Paper>
                    ))}
                </Stack>
            )}

            {!loading &&
                tests.length === 0 && (
                    <Paper
                        sx={{
                            mt: 3,
                            p: 5,
                            textAlign: "center",
                            borderRadius: 3,
                            border:
                                `1px solid ${COLORS.border}`,
                        }}
                    >
                        <Quiz
                            sx={{
                                fontSize: 50,
                                color:
                                    COLORS.camel,
                                mb: 1,
                            }}
                        />

                        <Typography
                            fontWeight={700}
                        >
                            {periodFilter
                                ? "No tests found for this period"
                                : "Select a period"}
                        </Typography>

                        <Typography
                            color={COLORS.gray}
                            fontSize={14}
                        >
                            {periodFilter
                                ? "Try another period or change your filters."
                                : "Choose a period above to load its tests."}
                        </Typography>
                    </Paper>
                )}

            {totalCount > 0 && (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: {
                            xs: "column",
                            sm: "row",
                        },
                        alignItems: "center",
                        justifyContent:
                            "space-between",
                        gap: 2,
                        mt: 3,
                        p: 2,
                        borderRadius: 3,
                        backgroundColor:
                            COLORS.white,
                        border:
                            `1px solid ${COLORS.border}`,
                    }}
                >
                    <Typography
                        fontSize={13}
                        color={COLORS.gray}
                    >
                        Showing{" "}
                        {((page - 1) * rowsPerPage) + 1}
                        {" - "}
                        {Math.min(
                            page * rowsPerPage,
                            totalCount
                        )}
                        {" of "}
                        {totalCount}
                    </Typography>

                    {totalPages > 1 && (
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={(
                                event,
                                value
                            ) => {
                                setPage(value);
                            }}
                            color="primary"
                            siblingCount={1}
                            boundaryCount={1}
                            sx={{
                                "& .MuiPaginationItem-root.Mui-selected":
                                    {
                                        backgroundColor:
                                            COLORS.orange,
                                        color:
                                            COLORS.white,
                                        fontWeight:
                                            700,
                                    },
                            }}
                        />
                    )}

                    <Select
                        size="small"
                        value={rowsPerPage}
                        onChange={event => {
                            setRowsPerPage(
                                Number(
                                    event.target.value
                                )
                            );

                            setPage(1);
                        }}
                    >
                        <MenuItem value={20}>
                            20 per page
                        </MenuItem>

                        <MenuItem value={50}>
                            50 per page
                        </MenuItem>

                        <MenuItem value={100}>
                            100 per page
                        </MenuItem>
                    </Select>
                </Box>
            )}

            <Dialog
                open={Boolean(deleteId)}
                onClose={cancelDelete}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle
                    sx={{
                        fontWeight: 800,
                    }}
                >
                    Delete Test?
                </DialogTitle>

                <DialogContent>
                    <Typography
                        color={COLORS.gray}
                    >
                        This action cannot be undone.
                        Are you sure you want to
                        permanently delete this test?
                    </Typography>
                </DialogContent>

                <DialogActions
                    sx={{
                        p: 2,
                    }}
                >
                    <Button
                        onClick={cancelDelete}
                        disabled={deleting}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleDelete}
                        disabled={deleting}
                    >
                        {deleting
                            ? "Deleting..."
                            : "Delete Test"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={editDialogOpen}
                onClose={() => {
                    if (!loading) {
                        setEditDialogOpen(false);
                        setSelectedTest(null);
                    }
                }}
                fullWidth
                maxWidth="xl"
                fullScreen={isMobile}
            >
                <DialogTitle
                    sx={{
                        backgroundColor:
                            COLORS.black,
                        color:
                            COLORS.white,
                        display: "flex",
                        justifyContent:
                            "space-between",
                        alignItems: "center",
                        fontWeight: 800,
                    }}
                >
                    Edit Test

                    <IconButton
                        onClick={() => {
                            setEditDialogOpen(false);
                            setSelectedTest(null);
                        }}
                        sx={{
                            color:
                                COLORS.white,
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>

<DialogContent
sx={{
    p: 0,
    backgroundColor: COLORS.cream,
    overflow: "auto",
    maxHeight: "calc(100vh - 80px)",

    "& .ant-card": {
        width: "100%",
    },

    "& .ant-card-body": {
        overflow: "visible",
    }
}}
>
{selectedTest && (
    <>
        {/* {console.log(
            "DIALOG SELECTED TEST:",
            selectedTest
        )} */}

        <Test
            key={selectedTest.id}
            editTest={selectedTest}
            onUpdated={async updatedTest => {
                setEditDialogOpen(false);
                setSelectedTest(null);
                await fetchTests();
            }}
        />
    </>
)}
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default TestPraint;


